import Config from '@src/config/Config';
import axios from 'axios';

const TIMEOUT_IN_MILLIS = 60000;

const api = axios.create({
  baseURL: Config.VITE_API_URL,
  timeout: TIMEOUT_IN_MILLIS,
  headers: { Accept: 'application/json' },
  maxRedirects: 0,
});

export const Client = api;
